module.exports = __webpack_public_path__ + "img/lovoo.e007292.png";